module.exports = __webpack_public_path__ + "static/media/layer-minus.6e198ad5.svg";